import _ from "lodash";

export class ConfigurationVariables {
  production: boolean;
  graphql: string;
  graphqlUser: string;
  auth: {
    urlPath: string;
    realm: string;
    clientID: string;
  }

  getEmptyFields(): string[] {
    return getEmptyFields(this);
  }

  tz() {
    // return moment.tz.guess(); PAP must be Warsaw
    return 'Europe/Warsaw';
  }
};

function getEmptyFields(obj: Object, prefix: string = ''): string[] {
  return _.compact(_.flattenDeep(_.keys(obj).map(field => {
    const fieldVal = _.get(obj, field);
    const fieldPath = `${prefix}${field}`;
    if (_.isObject(fieldVal)) {
      return getEmptyFields(fieldVal, `${fieldPath}.`)
    }
    return _.isNil(_.get(obj, field)) ? fieldPath : '';
  })));
}
